import styles from './TripTooltip.module.scss'
import Clock from '../../../pages/ControlSheet/assets/clock.svg'
import clsx from 'clsx'
import { ControlSheetNote } from '../types/types'
import { ControlSheetNotesViewer } from './ControlSheetNotesViewer'
import { AnnotationsPermission } from '@/pages/ControlSheet/ui/ControlSheetPage'
import { displayTime } from '../helpers/displayTime'

interface TripTooltipProps {
    tripNumber: string
    isNearDrivingHours?: boolean
    plannedTime?: string
    actualTime?: string
    notOperating?: boolean
    departingDepot?: string
    previous?: { trip: string; run: string; lateMealReliefMayAffect: boolean }
    notes: ControlSheetNote[]
    annotationsPermission?: AnnotationsPermission
}

export const TripTooltip = ({ ...props }: TripTooltipProps) => {
    const prev = (
        <>
            <div className={styles.heading}>Previous</div>
            <div>Trip {props.previous?.trip}</div>
            {props.previous?.lateMealReliefMayAffect && (
                <div className={styles.lateMealRelief}>Late meal relief may affect this departure</div>
            )}
        </>
    )

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.tripContainer}>
                    <span>Trip</span>
                    <span className={styles.tripNumber}>{props.tripNumber}</span>
                </div>
                {props.isNearDrivingHours && (
                    <div className={styles.nearDrivingHours}>
                        <Clock />
                        <span>Near Driving Hours</span>
                    </div>
                )}
            </div>
            <div className={styles.contentContainer}>
                {props.previous ? (
                    prev
                ) : props.departingDepot ? (
                    <div className={styles.departing}>
                        <div className={styles.heading}>Departing</div>
                        <div className={styles.value}>
                            <span>
                                {props.departingDepot} {displayTime(props.plannedTime)}
                            </span>
                        </div>
                    </div>
                ) : (
                    <div className={styles.plannedContainer}>
                        <div className={styles.heading}>Planned</div>
                        <div className={clsx(styles.timesContainer, styles.value)}>
                            {props.annotationsPermission !== 'none' && (
                                <div
                                    className={clsx({
                                        [styles.timesStrike]: props.actualTime,
                                    })}
                                >
                                    {props.notOperating ? 'Not operating' : displayTime(props.plannedTime)}
                                </div>
                            )}
                            {props.actualTime && <div>{displayTime(props.actualTime)}</div>}
                        </div>
                    </div>
                )}
            </div>

            {props.annotationsPermission !== 'none' && <ControlSheetNotesViewer notes={props.notes} />}
        </div>
    )
}
